// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__18WBF","left":"StickyBox_left__2h45X","right":"StickyBox_right__2oHG9"};